import { useEffect, useState } from "react";

/**
 * Custom hook that does :
 * - Compares only date portions (no time)
 * - Returns true if today >= announcementDate
 */
const useCampaignHidden = (announcementDate?: string) => {
  const [isHidden, setIsHidden] = useState(false);

  useEffect(() => {
    if (announcementDate) {
      const today = new Date();
      const announcement = new Date(announcementDate);

      const todayDateOnly = new Date(
        today.getFullYear(),
        today.getMonth(),
        today.getDate()
      );

      const announcementDateOnly = new Date(
        announcement.getFullYear(),
        announcement.getMonth(),
        announcement.getDate()
      );

      console.log(todayDateOnly, "====", announcementDateOnly);

      if (todayDateOnly >= announcementDateOnly) {
        setIsHidden(true);
      } else {
        setIsHidden(false);
      }
    }
  }, [announcementDate]);

  return isHidden;
};

export default useCampaignHidden;
